import "ie-array-find-polyfill"
import Layout from "../components/layout/layout"
import Kv from "../components/elements/kv/kv"
import commonData from "../data/common.json"
import { getRootSite } from "../src/lib/strapi/strapi-content";

export async function getServerSideProps(context) {
  const site = await getRootSite();
  const page = site.homePage;

  return {
    props: {
      currentPage: "/",
      pageCommon: commonData.pageCommon,
      meta: page.metadata,
      kv: {
        text: page.welcomeText,
        backgroundImage: page.backgroundImage,
        page: "short"
      },
      externalUrl: page.footerExternalUrl
    },
  }
}

class Index extends React.Component {
  render() {
    return (
      <Layout
        meta={this.props.meta}
        data={this.props.pageCommon}
        currentPagePath={this.props.currentPage}
        externalUrl={this.props.externalUrl}
        footerPos="relative"
        page="staticHead"
      >
        <Kv {...this.props.kv} />
      </Layout>
    )
  }
}
export default Index;
